var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTrades(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 28,
    viewBox: "0 0 38 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52169 14.5339L4.59811 11.6172",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3601 3.81445L5.04099 11.1336",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5768 5.55171L15.3996 5.33364H15.1202C14.3433 5.33364 13.6073 5.02697 13.0553 4.48178L12.367 3.80029",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 10.711L3.06472 13.1507L13.1507 3.06472L10.711 0.625",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4613 25.5467L20.2928 26.3781C20.9674 27.0528 22.0578 27.0528 22.7325 26.3781C23.4071 25.7034 23.4071 24.6131 22.7325 23.9384L21.7579 22.9639",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2655 21.4711L22.6371 23.8427C23.3117 24.5174 24.4021 24.5174 25.0768 23.8427C25.7514 23.168 25.7514 22.0776 25.0768 21.403L23.7002 20.0264",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7052 19.0388L25.0768 21.4104C25.7515 22.0851 26.8418 22.0851 27.5165 21.4104C28.1912 20.7357 28.1912 19.6454 27.5165 18.9707L25.1449 16.5991",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0351 26.331C16.3605 27.0057 15.2701 27.0057 14.5954 26.331C13.9207 25.6563 13.9207 24.566 14.5954 23.8913L16.0061 22.4806C16.6808 21.8059 17.7711 21.8059 18.4458 22.4806C19.1205 23.1553 19.1205 24.2457 18.4458 24.9203L17.0351 26.331Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1557 21.4511C11.481 22.1258 10.3906 22.1258 9.71596 21.4511C9.04129 20.7765 9.04129 19.6861 9.71596 19.0114L11.1266 17.6007C11.8013 16.9261 12.8917 16.9261 13.5664 17.6007C14.241 18.2754 14.241 19.3658 13.5664 20.0404L12.1557 21.4511Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71606 19.0117C9.04139 19.6863 7.95101 19.6863 7.27634 19.0117C6.60167 18.337 6.60167 17.2466 7.27634 16.572L8.68702 15.1613C9.36169 14.4866 10.4521 14.4866 11.1267 15.1613C11.8014 15.8359 11.8014 16.9263 11.1267 17.601L9.71606 19.0117Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5955 23.8911C13.9208 24.5657 12.8304 24.5657 12.1557 23.8911C11.4811 23.2164 11.4811 22.126 12.1557 21.4513L13.5664 20.0407C14.2411 19.366 15.3315 19.366 16.0061 20.0407C16.6808 20.7153 16.6808 21.8057 16.0061 22.4804L14.5955 23.8911Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9834 14.7316L33.1046 11.6172",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3084 3.81445L33.1931 11.7061",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1398 17.5873L27.5164 18.9639C28.1775 19.6249 29.261 19.6794 29.9425 19.0388C30.6581 18.371 30.6717 17.2465 29.9834 16.5582L23.5025 10.0773C22.9914 9.56619 22.3031 9.28678 21.5875 9.28678L18.4186 9.30041L16.9875 10.7315C15.9312 11.7878 14.3569 12.0195 13.0758 11.413C12.5306 11.154 12.4079 10.4385 12.8372 10.0092L16.7217 6.12469C17.2328 5.61357 17.9211 5.32735 18.6435 5.32735H22.5825C23.3594 5.32735 24.0954 5.02068 24.6474 4.47549L25.3152 3.81445",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0776 10.711L34.6379 13.1507L24.5519 3.06472L26.9916 0.625",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTrades);
export default __webpack_public_path__ + "static/media/newTrades.48bf40ff953a82dedca695a1f4103747.svg";
export { ForwardRef as ReactComponent };